// Configuração de ambiente (`spec/17-frontend.md` §9.4). Toda env `VITE_*` é pública
// por natureza: vai no bundle. Nenhum segredo aqui.

const DEFAULT_API_BASE_URL = 'http://localhost:3000';

function trimSlash(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}

export const API_BASE_URL = trimSlash(import.meta.env.VITE_API_BASE_URL ?? DEFAULT_API_BASE_URL);

export const APP_ENV = import.meta.env.VITE_APP_ENV ?? 'local';

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? '';

/**
 * Site key pública do Cloudflare Turnstile (SEC-01, `spec/17` §4.2). `''` = captcha
 * desligado no front (local sem chave, e o caso de a variável do ambiente vir vazia no
 * ambiente de build, `vars` ausente vira string vazia, não `undefined`).
 */
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '';

/** Hash do build, usado como `release` do Sentry. */
export const RELEASE = import.meta.env.VITE_RELEASE ?? 'dev';

const DEFAULT_DOCS_BASE_URL = 'https://docs.leztypay.com';

/** Base da doc pública (WEB-118, `spec/22-public-docs.md`). Sem segredo, mesma regra acima. */
export const DOCS_BASE_URL = trimSlash(import.meta.env.VITE_DOCS_BASE_URL ?? DEFAULT_DOCS_BASE_URL);
